var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-list__content" }, [
    _c("h2", { staticClass: "c-list__title" }, [
      _c("a", { staticClass: "c-list__link", attrs: { href: _vm.item.url } }, [
        _vm._v(_vm._s(_vm.item.title))
      ])
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "c-list__body",
      domProps: { innerHTML: _vm._s(_vm.item.body) }
    }),
    _vm._v(" "),
    _vm.validDate
      ? _c("dl", { staticClass: "c-list__meta" }, [
          _c("dt", { staticClass: "c-list__meta-title" }, [
            _vm._v("Publication Date")
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "c-list__meta-detail" }, [
            _c("time", { attrs: { datetime: _vm.item.publicationDate } }, [
              _vm._v(_vm._s(_vm._f("formatDate")(_vm.item.publicationDate)))
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-153e8048", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-153e8048","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/partnerhub/results/SearchItemPage.vue
// module id = 548
// module chunks = 0